import React from 'react';
import { PhotoIcon, ThreeDimensionalIcon, VideoIcon } from '@domain-group/fe-co-icon';
import { mediaStats, mediaItem, value, icon } from './media-stats.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var MediaStats = _ref => {
  var _ref$numPhotos = _ref.numPhotos,
    numPhotos = _ref$numPhotos === void 0 ? 0 : _ref$numPhotos,
    _ref$hasVideo = _ref.hasVideo,
    hasVideo = _ref$hasVideo === void 0 ? false : _ref$hasVideo,
    _ref$has3dTour = _ref.has3dTour,
    has3dTour = _ref$has3dTour === void 0 ? false : _ref$has3dTour;
  return ___EmotionJSX("div", {
    css: mediaStats
  }, numPhotos > 0 && ___EmotionJSX("div", {
    css: mediaItem
  }, ___EmotionJSX(PhotoIcon, {
    css: icon,
    size: "custom"
  }), ___EmotionJSX("span", {
    css: value
  }, numPhotos)), hasVideo && ___EmotionJSX("div", {
    css: mediaItem
  }, ___EmotionJSX(VideoIcon, {
    css: icon,
    size: "custom"
  })), has3dTour && ___EmotionJSX("div", {
    css: mediaItem
  }, ___EmotionJSX(ThreeDimensionalIcon, {
    css: icon,
    size: "custom"
  }), ___EmotionJSX("span", {
    css: value
  }, "3D")));
};